/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ExpenseList = {
    type: 'array',
    contains: {
        type: 'Expense',
    },
};